import { useEffect, useMemo } from "react";

export const useReceiveMessage = (callback: any) => {
  const receiveMessage = useMemo(() => {
    return (event: any) => {
      const { data } = event;
      callback(data);
    };
  }, [callback]);

  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);
    return () => {
      window.removeEventListener("message", receiveMessage);
    };
  }, [receiveMessage]);
};
